import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { UsersView } from './users-view';

function usersViewRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/view/:id`}
      render={() => (
        <>
          <UsersView />
        </>
      )}
    />
  );
}

export { usersViewRoute };
